import React from 'react';
import styled from 'styled-components'

const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const ImageStyled = styled.img`
    display: inherit;
    object-fit: contain;
    // height: 450px;
    width: 70%;
`;


const ImageSpeakers = ({ image }) => {
    return (
        <ImageContainer>
            <ImageStyled src={image} alt="" />
        </ImageContainer>
    )
}

export default ImageSpeakers;